<adapt-feature-guidance [configItem]="configItem">
    <p>Set the basic details for the group, as well as ending or deleting the group.</p>
</adapt-feature-guidance>

<adapt-feature-configuration [configItem]="configItem">
    @if (team) {
        <div class="row">
            <div class="col-md-6">
                <!-- name -->
                <div class="form-group">
                    <label for="teamNameLabel">Name</label>
                    <dx-text-box id="teamNameLabel"
                                 [adaptValidateEntity]="team"
                                 adaptValidateEntityProperty="name"
                                 [readOnly]="!isActive"
                                 [(value)]="team.name"
                                 data-test="team-name-input"></dx-text-box>
                    <dx-check-box *adaptIfAlto="false"
                                  class="mt-2"
                                  [value]="team.isPrivate"
                                  (valueChange)="onPrivateChanged($any($event))"
                                  text="Private group"></dx-check-box>
                </div>
                <div class="form-group">
                    <label>Labels</label>
                    <adapt-select-label-for-related-entity [team]="team"
                                                           (entitiesChange)="changedLabelLocationEntities = $event">
                    </adapt-select-label-for-related-entity>
                </div>
                <ng-container *adaptIfAlto="false">
                    <div class="form-group">
                        <label for="teamTypeConfig">Type</label>
                        <adapt-select-team-type [(teamTypeConfiguration)]="team.teamTypeConfiguration"
                                                data-test="select-team-type"></adapt-select-team-type>
                    </div>

                    <!-- start-date -->
                    <div class="form-group">
                        <label for="startDate">Start date</label>
                        <dx-date-box id="startDate"
                                     type="date"
                                     [value]="team.startDate"
                                     [max]="maxStartDate"
                                     [readOnly]="!isActive"
                                     (valueChange)="team.startDate = $any($event)">
                            <dx-validator>
                                <dxi-validation-rule type="required"
                                                     message="Start date is required"></dxi-validation-rule>
                            </dx-validator>
                        </dx-date-box>
                    </div>
                    <!-- end-date -->
                    @if (team.endDate) {
                        <div class="form-group">
                            <label for="endDate">End date</label>
                            <div id="endDate">
                                {{ team.endDate | adaptDate }}
                            </div>
                        </div>
                    }
                    <!-- buttons to end, delete or restore team -->
                    @if ((isLeaderTeam$ | async) && isActive) {
                        <div class="alert alert-secondary">This group is currently set to be the leadership group for any resilient
                            business assessment surveys. You will need to update the resilient business assessment configuration in the
                            organisation configuration before ending or deleting this group.</div>
                    } @else {
                        @if (isActive) {
                            <label class="pt-4">Deactivate group</label>
                            <div>
                                This preserves all data for this group in the organisation, but the group will not be
                                accessible. All people will be removed from the group, and all action boards will be archived.
                                <button class="d-block"
                                        adaptButtonIcon="fal fa-fw fa-stop-circle"
                                        (click)="deactivateTeam()">Deactivate group</button>
                            </div>
                        } @else {
                            <label class="pt-4">Reactivate group</label>
                            <div>
                                Reactivating the group will make it visible to everyone in the organisation.<br>
                                After reactivating the group, update any required data using this configuration page (such as the people, action boards, active features).
                                <button class="d-block"
                                        adaptButtonIcon="fal fa-fw fa-stop-circle"
                                        (click)="reactivateTeam()">Reactivate group</button>
                            </div>
                        }
                        <label class="pt-3">Delete group</label>
                        <div>
                            This is a destructive operation and all data associated with the group will be deleted.
                            <button class="d-block"
                                    adaptButton="delete"
                                    (click)="deleteTeam()">group</button>
                        </div>
                    }
                </ng-container>
            </div>
        </div>
    }
</adapt-feature-configuration>
